import $ from 'jquery';
export default class Popover {
    static init() {
        const $element = $('[data-toggle="popover"]');
        $element.popover();
        $element.on('inserted.bs.popover', e => {
            const $popoverButton = $(e.currentTarget);
            $('.js__popover-footer').remove();
            this.addPopoverFooter($($popoverButton.data('popover-footer')));
        });
        $element.on('hide.bs.popover', e => {
            $('.js__popover-footer').remove();
        });
        $element.on('show.bs.popover', e => {
            $('.js__popover-footer').remove();
            const $popover = $('.popover');
            $popover.first().popover('hide');
        });
        $(document).on('click', e => {
            const $element = $(e.target);
            const $popover = $('.popover');
            if (!$element.closest('[data-toggle="popover"]').length && !$element.closest('.popover').length) {
                $popover.popover('hide');
            }
        });
    }
    static addPopoverFooter($footer) {
        const $popover = $('.popover');
        $popover.append($footer);
        const $closePopoverButton = $popover.find('.js__close-popover');
        $popover.trigger('focus');
        $closePopoverButton.on('click', () => {
            $popover.popover('hide');
        });
    }
}
